import { $, _, Backbone, moment, Radio } from "../../../../vendor";
import InboomaBaseView from "../../InboomaBaseView";
import { Backform, Biscuit, Notification } from "../../../utils";
import * as FileSaver from "../../../../vendor/FileSaver";

import SalesBilling from "../../../models/SalesBilling";

import OffCanvasSalesBillingsFormTpl from "../../../templates/orders/SalesBillings/OffCanvasSalesBillingsFormTpl.html";
import OffCanvasBehavior from "../../../behaviors/Behavior.OffCanvas";
import { getApiHost } from "../../../Sync";
import { appRollingLoaderAnim } from "../../AppAnnouncements";

export default InboomaBaseView.extend({
  template: OffCanvasSalesBillingsFormTpl,
  parentView: "finances/sales_billings",
  el: "#inb-off-canvas",

  initialize() {
    this.isNew = this.model.get("id") === "";
    this.render();
  },

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      openCanvas: (view) => {
        if (typeof view.options.openCanvas != "undefined") {
          return view.options.openCanvas;
        }
        return true;
      },
      beforeSave: (model, view) => {
        if (model.get("id") === null) {
          model.set("client_id", Number(Biscuit.get("user.client_id")));
        }

        if (
          (typeof model.get("location") === "undefined" ||
            model.get("location") === null ||
            model.get("location") === "") &&
          Number(Biscuit.get("user.client_id")) === 7
        ) {
          $(".inbooma-select-box__input").css("border-color", "red");
          $("div.inb-loader.inb-loader--small").addClass("hide");
          let y = document.getElementsByClassName("off-canvas__form-error");
          let error = y[0];
          error.innerHTML = view.t("form_validation_error");
          error.classList.remove("hide");

          return true;
        } else {
          $(".inbooma-select-box__input").css("border-color", "#e3e3e3");
        }

        const date = moment(model.get("date"));
        if (Number(Biscuit.get("user.client_id")) === 7) {
          const location = Radio.channel("locations")
            .request("get:data")
            .get(model.get("location"));

          model.set({
            location_id: model.get("location"),
            location_name: location.get("name"),
            date: date.format("YYYY-MM"),
          });
        }

        delete model.attributes.location;
        delete model.attributes.file;
      },
      afterSaveSuccess: (model, view, response) => {
        let isCreating = response.data.id !== undefined;

        model = new SalesBilling(model.toJSON());

        if (model.get("created") == "" || _.isNull(model.get("created"))) {
          model.set("created", moment().toISOString());
        }

        view.collection.set(model, { add: true, merge: true, remove: false });

        new Notification({
          message:
            view.t(
              view.isNew ? "saved_${a}" : "updated_${a}",
              { a: view.t("sales_billing") },
              "capital",
            ) +
            ' "' +
            moment(model.get("date")).format("MMMM YYYY") +
            '".',
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });
      },

      afterSaveError: (model, view, response) => {
        view.$el.find(".rollingLoader").fadeOut("fast");
        model.set("location", model.get("location_id"));

        let message = view.t("request_error");

        if (response.status === 404 || response.statusText === "Not Found") {
          message = view.t("orders_sales_billings_error");
        }

        if (typeof response.responseJSON !== "undefined") {
          const data = response.responseJSON.data;

          if (response.status === 423 && typeof data.message !== "undefined") {
            message = view.t("sales_billing_already_exists");
          }

          if (
            typeof data !== "undefined" &&
            typeof data.errors !== "undefined" &&
            (typeof data.errors.sales_billing_value !== "undefined") &
              typeof data.errors.sales_billing_value.greaterThanOrEqual
          ) {
            message = view.t("sales_billing_error_value_greater_equal");
          }
        }

        new Notification({
          message,
          duration: 6000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      },
    },
  ],

  onRender() {
    const that = this,
      locations = Radio.channel("locations").request("get:data"),
      users = Radio.channel("users").request("get:data");
    // @todo Is the following variable actually required?
    const model = new Backbone.Model({
      date: new Date(),
      on: null,
    });

    let managerHasLocations =
      Biscuit.get("user.role") == "manager-location" ? Biscuit.get("user.user_locations") : "";

    if (managerHasLocations !== "") {
      managerHasLocations = managerHasLocations.split(",");
    }

    //const locations = this.model.get('locations');
    let locationsOptions = [];
    let userOptions = [];

    _.map(locations.models, (location) => {
      if (managerHasLocations.length && !_.contains(managerHasLocations, location.id.toString())) {
        return;
      }

      locationsOptions.push({
        label: location.get("name"),
        value: location.get("id"),
      });
    });

    _.map(users.models, (user) => {
      userOptions.push({
        label: user.get("last_name") + ", " + user.get("first_name"),
        value: user.get("id"),
      });
    });
    let fields = [];
    if (Number(Biscuit.get("user.client_id")) === 7) {
      fields = [
        {
          name: "date",
          label: this.t("date", null, "capital"),
          helpMessage: this.t("monthpicker_help"),
          control: "datepicker",
          format: "MMMM YYYY",
          extraTopClasses: ["inbooma-month-picker"],
          maxDate: new Date(),
          size: {
            large: "4",
          },
        },
      ];
    } else {
      fields = [
        {
          control: "spacer",
        },
        {
          control: "uneditable-input",
          label: this.t("create own invoice"),
          size: {
            large: "12",
          },
        },
        /*{
                      name: "switch1",
                      label: this.t('switch',null,'capital'),
                      control: "radio",
                      options: [
                          {label: this.t('total',null,'capital'), value: "total"},
                          {label: this.t('select month',null,'capital'), value: "month"}
                      ],
                      size: {
                          "large": "12",
                          "medium": "12"
                      }
                  },*/
        {
          name: "dateA",
          label: this.t("date", null, "capital"),
          helpMessage: this.t("monthpicker_help"),
          control: "datepicker",
          format: "MMMM YYYY",
          extraTopClasses: ["inbooma-month-picker date client-date /*hide*/"],
          maxDate: new Date(),
          size: {
            large: "4",
          },
        },
        {
          control: "uneditable-input",
          label: "",
          extraTopClasses: ["space_1"],
          size: {
            large: "12",
          },
        },
      ];
    }
    if (Number(Biscuit.get("user.client_id")) === 7) {
      fields.push({
        name: "location",
        label: this.t("location", null, "capital"),
        control: "selector",
        required: true,
        collection: "locations",
        sortBy: "name",
        extraTopClasses: ["locations"],
        forceFirstSelected: true,
        placeholder: this.t("select_${a}", { a: this.t("location") }, "capital"),
        options: locationsOptions,
        size: {
          large: "4",
        },
      });
      fields.push({
        name: "save",
        label: this.t("preview", null, "capital"),
        control: "button",
        extraClasses: [
          "button-generateI button medium beautify beautify-" +
            Biscuit.get("user.client_id") +
            " round",
        ],
        size: {
          large: "1",
          medium: "1",
          small: "2",
        },
      });
      fields.push({
        name: "savei",
        label: this.t("save", null, "capital"),
        style: "padding-left: 30px;",
        control: "button",
        extraClasses: ["button-generateI-save medium beautify button-submit round pad"],
        size: {
          large: "1",
          medium: "1",
          small: "2",
        },
      });
    } else {
      fields.push({
        name: "save",
        label: this.t("preview", null, "capital"),
        control: "button",
        extraClasses: ["button-generate button medium beautify round saveb"],
        size: {
          large: "1",
          medium: "1",
          small: "2",
        },
      });
      fields.push({
        name: "savec",
        label: this.t("save", null, "capital"),
        style: "padding-left: 30px;",
        control: "button",
        extraClasses: ["button-generate-save medium beautify button-submit round pad"],
        size: {
          large: "1",
          medium: "1",
          small: "2",
        },
      });
      /*fields.push(
                  {
                      control: "spacer",

                  }
              );
              fields.push({
                  control: "uneditable-input",
                      label: this.t('create user invoice'),
                  size: {
                  "large": "12"
              }
              });*/
      /*    fields.push(
                  {
                      name: "switch2",
                      label: this.t('switch',null,'capital'),
                      control: "radio",
                      extraTopClasses: ['float-left'],
                      options: [
                          {label: this.t('total',null,'capital'), value: "total"},
                          {label: this.t('select month',null,'capital'), value: "month"}
                      ],
                      size: {
                          "large": "12",
                          "medium": "12"
                      }
                  },
                  {
                      name: "dateB",
                      label: this.t('date', null, 'capital'),
                      helpMessage: this.t('monthpicker_help'),
                      control: "datepicker",
                      format: 'MMMM YYYY',
                      extraTopClasses: ['inbooma-month-picker date user-date hide'],
                      maxDate: new Date(),
                      size: {
                          "large": "4"
                      }
                  }
              );
              fields.push(
                  {
                      name: 'user',
                      label: this.t('user',null,'capital'),
                      control: "selector",
                      required: true,
                      collection: 'users',
                      sortBy: 'last_name',
                      extraTopClasses: ['users'],
                      forceFirstSelected: true,
                      placeholder: this.t('select_${a}', {a: this.t('user')}, 'capital'),
                      options: userOptions,
                      size: {
                          "large": "4"
                      }
                  });
              fields.push(

                  {
                      control: "uneditable-input",
                      label: '',
                      extraTopClasses: ['space_1'],
                      size: {
                          "large": "12"
                      }
                  },
                  {
                      name: "save",
                      label: this.t('preview', null, 'capital'),
                      control: "button",
                      extraClasses: ['button-generate-user button medium beautify round'],
                      size: {
                          "large": "1",
                          "medium": "1",
                          "small": "2"
                      }
                  });
                  fields.push( {
                      name: "savec",
                      label: this.t('save', null, 'capital'),
                      control: "button",
                      extraClasses: ['button-generate-user-save button medium beautify round pad'],
                      size: {
                          "large": "1",
                          "medium": "1",
                          "small": "2"
                      }
                  });
              fields.push({
                      control: "spacer"
                  }
              );*/
    }
    /*,
            {
                name: "save_sales_billing",
                label : this.t('save',null,'capital'),
                control : "button",
                extraClasses : ['button medium beautify button-submit round'],
                size: {
                    "large" : "2",
                    "medium" : "2",
                    "small" : "2"
                }
            }*/

    this.form = new Backform.Form({
      that: that,
      el: that.$el.find("form"),
      model: this.model,
      fields: fields,
      events: {
        "click .button-generate"(ev) {
          ev.preventDefault();

          $(".select2-selection").css("border-color", "#e3e3e3");

          let images = document.getElementsByClassName("rollingLoader");
          let img = images[0];

          if (typeof img !== "undefined") {
            img.parentNode.removeChild(img);
          }

          const date = moment(this.model.get("dateA"));

          let y = document.getElementsByClassName("off-canvas__form-error");
          let error = y[0];

          if (
            !date.isValid() /* && (Number(Biscuit.get('user.client_id')) === 7 || (typeof model.get('switch1') !== 'undefined' && model.get('switch1') === 'month' ))*/
          ) {
            error.innerHTML = that.t("invalid_time_format");
            error.classList.remove("hide");
            $(".select2-selection").css("border-color", "red");

            return;
          }
          if (
            Number(Biscuit.get("user.client_id")) === 7 &&
            (that.model.get("location") === null ||
              that.model.get("location") === "" ||
              typeof that.model.get("location") === "undefined")
          ) {
            error.innerHTML = that.t("no_location_selected");
            error.classList.remove("hide");
            $(".select2-selection").css("border-color", "red");

            return;
          }
          let location = Radio.channel("locations").request("get:data");
          if (Number(Biscuit.get("user.client_id")) === 7) {
            location = Radio.channel("locations")
              .request("get:data")
              .get(that.model.get("location"));
          }

          that.$el.find(".button-generate").prepend(appRollingLoaderAnim);

          const xmlHttp = new XMLHttpRequest();

          if (Number(Biscuit.get("user.client_id")) === 7) {
            xmlHttp.open(
              "GET",
              getApiHost() +
                "/sales_billings/generate?date=" +
                date.format("YYYY-MM") +
                "&location_id=" +
                location.get("id"),
              true,
            );
          } else {
            //if(this.model.get('switch1') == 'month') {
            xmlHttp.open(
              "GET",
              getApiHost() +
                "/sales_billings/generate?date=" +
                date.format("YYYY-MM") +
                "&client_id=" +
                Number(Biscuit.get("user.client_id")),
              true,
            );
            /* } else {
                              xmlHttp.open("GET", getApiHost() + '/sales_billings/generate?client_id=' + Number(Biscuit.get('user.client_id')), true);
                          }*/
          }
          // Backbone/jQuery AJAX would fail here -> fallback to native xhr
          xmlHttp.setRequestHeader("Accept", "application/json");
          xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
          xmlHttp.responseType = "blob";

          xmlHttp.onerror = function () {
            new Notification({
              message: that.t("orders_sales_billings_error"),
              duration: 6000,
              type: "warning",
              closeable: true,
              icon: "fi fi-x",
            });
            let images = document.getElementsByClassName("rollingLoader");

            _.each(images, (image) => {
              image.parentNode.removeChild(image);
            });
          };

          xmlHttp.onload = function () {
            that.$(".button-generate img").remove();
            let message = that.t("orders_sales_billings_error");
            let images = document.getElementsByClassName("rollingLoader");

            _.each(images, (image) => {
              image.parentNode.removeChild(image);
            });

            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
              new Notification({
                message,
                duration: 6000,
                type: "warning",
                closeable: true,
                icon: "fi fi-x",
              });

              return;
            }

            if (
              xmlHttp.status === 404 ||
              (typeof xmlHttp.response.size !== "undefined" && xmlHttp.response.size === 13)
            ) {
              new Notification({
                message,
                duration: 6000,
                type: "warning",
                closeable: true,
                icon: "fi fi-x",
              });

              return;
            }

            const blob = new Blob([xmlHttp.response], { type: "application/pdf" });

            // Unfortunately, xmlHttp.getResponseHeader('Content-Disposition'); is null so we have to
            // re-create the file name
            if (Number(Biscuit.get("user.client_id")) === 7) {
              FileSaver.saveAs(
                blob,
                "Umsatzabrechnung_" +
                  location.get("name").replace(/\s/g, "_") +
                  "_" +
                  date.format("MMMM_YYYY") +
                  ".pdf",
              );
            } else {
              if (Biscuit.get("user.role") === "user") {
                FileSaver.saveAs(blob, "Rechnung_" + date.format("DD._MMMM_YYYY") + ".pdf");
              } else {
                FileSaver.saveAs(blob, "Umsatzabrechnung_" + date.format("MMMM_YYYY") + ".pdf");
              }
            }
          };

          xmlHttp.send(null);
        },
        "click .button-generateI"(ev) {
          ev.preventDefault();

          $(".select2-selection").css("border-color", "#e3e3e3");

          let images = document.getElementsByClassName("rollingLoader");
          let img = images[0];

          if (typeof img !== "undefined") {
            img.parentNode.removeChild(img);
          }

          const date = moment(this.model.get("date"));

          let y = document.getElementsByClassName("off-canvas__form-error");
          let error = y[0];

          if (!date.isValid()) {
            error.innerHTML = that.t("invalid_time_format");
            error.classList.remove("hide");
            $(".select2-selection").css("border-color", "red");

            return;
          }
          if (
            that.model.get("location") === null ||
            that.model.get("location") === "" ||
            typeof that.model.get("location") === "undefined"
          ) {
            error.innerHTML = that.t("no_location_selected");
            error.classList.remove("hide");
            $(".select2-selection").css("border-color", "red");

            return;
          }
          let location = Radio.channel("locations").request("get:data");
          location = Radio.channel("locations").request("get:data").get(that.model.get("location"));

          that.$el.find(".button-generateI").prepend(appRollingLoaderAnim);

          const xmlHttp = new XMLHttpRequest();

          xmlHttp.open(
            "GET",
            getApiHost() +
              "/sales_billings/generate?date=" +
              date.format("YYYY-MM") +
              "&location_id=" +
              location.get("id"),
            true,
          );

          // Backbone/jQuery AJAX would fail here -> fallback to native xhr
          xmlHttp.setRequestHeader("Accept", "application/json");
          xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
          xmlHttp.responseType = "blob";

          xmlHttp.onerror = function () {
            new Notification({
              message: that.t("orders_sales_billings_error"),
              duration: 6000,
              type: "warning",
              closeable: true,
              icon: "fi fi-x",
            });
            let images = document.getElementsByClassName("rollingLoader");

            _.each(images, (image) => {
              image.parentNode.removeChild(image);
            });
          };

          xmlHttp.onload = function () {
            that.$(".button-generate img").remove();
            let message = that.t("orders_sales_billings_error");
            let images = document.getElementsByClassName("rollingLoader");

            _.each(images, (image) => {
              image.parentNode.removeChild(image);
            });

            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
              new Notification({
                message,
                duration: 6000,
                type: "warning",
                closeable: true,
                icon: "fi fi-x",
              });

              return;
            }

            if (
              xmlHttp.status === 404 ||
              (typeof xmlHttp.response.size !== "undefined" && xmlHttp.response.size === 13)
            ) {
              new Notification({
                message,
                duration: 6000,
                type: "warning",
                closeable: true,
                icon: "fi fi-x",
              });

              return;
            }

            const blob = new Blob([xmlHttp.response], { type: "application/pdf" });

            // Unfortunately, xmlHttp.getResponseHeader('Content-Disposition'); is null so we have to
            // re-create the file name
            if (Number(Biscuit.get("user.client_id")) === 7) {
              FileSaver.saveAs(
                blob,
                "Umsatzabrechnung_" +
                  location.get("name").replace(/\s/g, "_") +
                  "_" +
                  date.format("MMMM_YYYY") +
                  ".pdf",
              );
            } else {
              if (Biscuit.get("user.role") === "user") {
                FileSaver.saveAs(blob, "Rechnung_" + date.format("DD._MMMM_YYYY") + ".pdf");
              } else {
                FileSaver.saveAs(blob, "Umsatzabrechnung_" + date.format("MMMM_YYYY") + ".pdf");
              }
            }
          };

          xmlHttp.send(null);
        },
        "click .button-generate-user"(ev) {
          ev.preventDefault();

          $(".select2-selection").css("border-color", "#e3e3e3");

          let images = document.getElementsByClassName("rollingLoader");
          let img = images[0];

          if (typeof img !== "undefined") {
            img.parentNode.removeChild(img);
          }

          const date = moment(this.model.get("dateB"));

          let y = document.getElementsByClassName("off-canvas__form-error");
          let error = y[0];

          if (
            !date.isValid() &&
            typeof model.get("switch2") !== "undefined" /*&& model.get('switch2') === 'month'*/
          ) {
            error.innerHTML = that.t("invalid_time_format");
            error.classList.remove("hide");
            $(".select2-selection").css("border-color", "red");

            return;
          }

          const userId = this.model.get("user");

          if (typeof userId === "undefined" || userId === "" || userId === null) {
            error.innerHTML = that.t("please select user");
            error.classList.remove("hide");
            $(".users").css("border-color", "red");
          }

          that.$el.find(".button-generate-user").prepend(appRollingLoaderAnim);

          const xmlHttp = new XMLHttpRequest();

          // if(this.model.get('switch2') === 'month') {
          xmlHttp.open(
            "GET",
            getApiHost() +
              "/sales_billings/generate?date=" +
              date.format("YYYY-MM") +
              "&user_id=" +
              userId,
            true,
          );
          /* } else {
                          xmlHttp.open("GET", getApiHost() + '/sales_billings/generate?user_id=' + userId, true);
                      }
*/
          // Backbone/jQuery AJAX would fail here -> fallback to native xhr
          xmlHttp.setRequestHeader("Accept", "application/json");
          xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
          xmlHttp.responseType = "blob";

          xmlHttp.onerror = function () {
            new Notification({
              message: that.t("orders_sales_billings_error"),
              duration: 6000,
              type: "warning",
              closeable: true,
              icon: "fi fi-x",
            });
            let images = document.getElementsByClassName("rollingLoader");

            _.each(images, (image) => {
              image.parentNode.removeChild(image);
            });
          };

          xmlHttp.onload = function () {
            that.$(".button-generate img").remove();
            let message = that.t("orders_sales_billings_error");
            let images = document.getElementsByClassName("rollingLoader");

            _.each(images, (image) => {
              image.parentNode.removeChild(image);
            });

            if (xmlHttp.status === 500 || xmlHttp.status === 400) {
              new Notification({
                message,
                duration: 6000,
                type: "warning",
                closeable: true,
                icon: "fi fi-x",
              });
              let images = document.getElementsByClassName("rollingLoader");

              _.each(images, (image) => {
                image.parentNode.removeChild(image);
              });
              return;
            }

            if (
              xmlHttp.status === 404 ||
              (typeof xmlHttp.response.size !== "undefined" && xmlHttp.response.size === 13)
            ) {
              new Notification({
                message,
                duration: 6000,
                type: "warning",
                closeable: true,
                icon: "fi fi-x",
              });
              let images = document.getElementsByClassName("rollingLoader");

              _.each(images, (image) => {
                image.parentNode.removeChild(image);
              });
              return;
            }

            const blob = new Blob([xmlHttp.response], { type: "application/pdf" });

            // Unfortunately, xmlHttp.getResponseHeader('Content-Disposition'); is null so we have to
            // re-create the file name

            if (Biscuit.get("user.role") === "user") {
              FileSaver.saveAs(blob, "Rechnung_" + date.format("DD._MMMM_YYYY") + ".pdf");
            } else {
              FileSaver.saveAs(blob, "Umsatzabrechnung_" + date.format("MMMM_YYYY") + ".pdf");
            }
          };

          xmlHttp.send(null);
        },
        "change .switch2"(ev1) {
          if (that.model.get("switch2") === "month") {
            $(".user-date").removeClass("hide");
            $(".user-date").trigger("change");
          } else {
            $(".user-date").addClass("hide");
          }
        },
        /*"change .switch1"(ev2){
                      if(that.model.get('switch1') === 'month'){
                          $('.client-date').removeClass('hide');
                          $('.client-date').trigger('change');
                      } else {
                          $('.client-date').addClass('hide');
                      }

                  },*/
        "click .button-generate-user-save"(ev) {
          ev.preventDefault();
          let images = document.getElementsByClassName("rollingLoader");
          let img = images[0];

          if (typeof img !== "undefined") {
            img.parentNode.removeChild(img);
          }
          this.$el.find(".button-generate-user-save").prepend(appRollingLoaderAnim);
          this.model.set("client_id", Number(Biscuit.get("user.client_id")));

          //  this.model.set('what','user');
          const date = moment(this.model.get("dateB"));
          if (this.model.get("switch2") === "month") {
            this.model.set({
              user_id: this.model.get("user"),
              date: date.format("YYYY-MM"),
            });
          } else {
            delete this.model.attributes.date;
            this.model.set({
              user_id: this.model.get("user"),
            });
          }
          delete this.model.attributes.user;
          delete this.model.attributes.id;
          delete this.model.attributes.dateA;
          delete this.model.attributes.dateB;

          //  delete(this.model.attributes.switch1);
          delete this.model.attributes.switch2;
          this.model.save(
            {},
            {
              success: function (model, response, options) {
                let isCreating = response.data.id !== undefined;

                model = new SalesBilling(model.toJSON());

                if (model.get("created") == "" || _.isNull(model.get("created"))) {
                  model.set("created", moment().toISOString());
                }

                that.collection.set(model, { add: true, merge: true, remove: false });

                new Notification({
                  message:
                    this.view.t(
                      this.view.isNew ? "saved_${a}" : "updated_${a}",
                      { a: that.t("sales_billing") },
                      "capital",
                    ) +
                    ' "' +
                    moment(model.get("date")).format("MMMM YYYY") +
                    '".',
                  duration: 5000,
                  type: "success",
                  closeable: true,
                  icon: "fi fi-check",
                });
                let images = document.getElementsByClassName("rollingLoader");

                _.each(images, (image) => {
                  image.parentNode.removeChild(image);
                });
                $(".button-abort").trigger("click");
              },
              error: function (model, response, options) {
                let message = that.t("request_error");

                if (response.status === 404 || response.statusText === "Not Found") {
                  message = that.t("orders_sales_billings_error");
                }

                if (typeof response.responseJSON !== "undefined") {
                  const data = response.responseJSON.data;

                  if (response.status === 423 && typeof data.message !== "undefined") {
                    message = that.t("sales_billing_already_exists");
                  }

                  if (
                    typeof data !== "undefined" &&
                    typeof data.errors !== "undefined" &&
                    (typeof data.errors.sales_billing_value !== "undefined") &
                      typeof data.errors.sales_billing_value.greaterThanOrEqual
                  ) {
                    message = that.t("sales_billing_error_value_greater_equal");
                  }
                }

                new Notification({
                  message,
                  duration: 6000,
                  type: "warning",
                  closeable: true,
                  icon: "fi fi-x",
                });
                let images = document.getElementsByClassName("rollingLoader");

                _.each(images, (image) => {
                  image.parentNode.removeChild(image);
                });
              },
            },
          );
        },
        "click .button-generate-save"(ev) {
          ev.preventDefault();
          let images = document.getElementsByClassName("rollingLoader");
          let img = images[0];

          if (typeof img !== "undefined") {
            img.parentNode.removeChild(img);
          }
          this.$el.find(".button-generate-save").prepend(appRollingLoaderAnim);
          this.model.set("client_id", Number(Biscuit.get("user.client_id")));
          const date = moment(this.model.get("dateA"));

          // if (this.model.get('switch1') === 'month') {
          this.model.set({
            date: date.format("YYYY-MM"),
          });
          /* } else {
                          delete(this.model.attributes.date);
                      }*/
          delete this.model.attributes.user;
          delete this.model.attributes.id;
          //  delete(this.model.attributes.dateA);
          //  delete(this.model.attributes.dateB);

          //  delete(this.model.attributes.switch1);
          // delete(this.model.attributes.switch2);

          this.model.save(
            {},
            {
              success: function (model, response, options) {
                let isCreating = response.data.id !== undefined;

                model = new SalesBilling(model.toJSON());

                if (model.get("created") == "" || _.isNull(model.get("created"))) {
                  model.set("created", moment().toISOString());
                }

                that.collection.set(model, { add: true, merge: true, remove: false });
                new Notification({
                  message:
                    that.t(
                      that.isNew ? "saved_${a}" : "updated_${a}",
                      { a: that.t("sales_billing") },
                      "capital",
                    ) +
                    ' "' +
                    moment(date).format("MMMM YYYY") +
                    '".',
                  duration: 5000,
                  type: "success",
                  closeable: true,
                  icon: "fi fi-check",
                });
                let images = document.getElementsByClassName("rollingLoader");

                _.each(images, (image) => {
                  image.parentNode.removeChild(image);
                });
                $(".button-abort").trigger("click");
              },
              error: function (model, response, options) {
                let message = that.t("request_error");

                if (response.status === 404 || response.statusText === "Not Found") {
                  message = that.t("orders_sales_billings_error");
                }

                if (response.statusText === "error") {
                  message = that.t("orders_sales_billings_error");
                }

                if (typeof response.responseJSON !== "undefined") {
                  const data = response.responseJSON.data;

                  if (response.status === 423 && typeof data.message !== "undefined") {
                    message = that.t("sales_billing_already_exists");
                  }

                  if (
                    typeof data !== "undefined" &&
                    typeof data.errors !== "undefined" &&
                    (typeof data.errors.sales_billing_value !== "undefined") &
                      typeof data.errors.sales_billing_value.greaterThanOrEqual
                  ) {
                    message = that.t("sales_billing_error_value_greater_equal");
                  }
                }

                new Notification({
                  message,
                  duration: 6000,
                  type: "warning",
                  closeable: true,
                  icon: "fi fi-x",
                });
                model.set("dateA", date);
                let images = document.getElementsByClassName("rollingLoader");

                _.each(images, (image) => {
                  image.parentNode.removeChild(image);
                });
              },
            },
          );
        },
        "click .button-generateI-save"(ev) {
          ev.preventDefault();
          let images = document.getElementsByClassName("rollingLoader");
          let img = images[0];

          if (typeof img !== "undefined") {
            img.parentNode.removeChild(img);
          }
          this.$el.find(".button-generateI-save").prepend(appRollingLoaderAnim);
          this.model.set("client_id", Number(Biscuit.get("user.client_id")));

          if (
            (typeof this.model.get("location") === "undefined" ||
              this.model.get("location") === null ||
              this.model.get("location") === "") &&
            Number(Biscuit.get("user.client_id")) === 7
          ) {
            $(".inbooma-select-box__input").css("border-color", "red");
            $("div.inb-loader.inb-loader--small").addClass("hide");
            let y = document.getElementsByClassName("off-canvas__form-error");
            let error = y[0];
            error.innerHTML = view.t("form_validation_error");
            error.classList.remove("hide");

            return true;
          } else {
            $(".inbooma-select-box__input").css("border-color", "#e3e3e3");
          }

          const date = moment(this.model.get("date"));
          if (Number(Biscuit.get("user.client_id")) === 7) {
            const location = Radio.channel("locations")
              .request("get:data")
              .get(this.model.get("location"));

            this.model.set({
              location_id: this.model.get("location"),
              location_name: location.get("name"),
              date: date.format("YYYY-MM"),
            });
          }

          delete this.model.attributes.location;
          delete this.model.attributes.file;

          delete this.model.attributes.user;
          delete this.model.attributes.id;
          delete this.model.attributes.dateA;
          delete this.model.attributes.dateB;

          //delete(this.model.attributes.switch1);
          delete this.model.attributes.switch2;

          this.model.save(
            {},
            {
              success: function (model, response, options) {
                let isCreating = response.data.id !== undefined;

                model = new SalesBilling(model.toJSON());

                if (model.get("created") == "" || _.isNull(model.get("created"))) {
                  model.set("created", moment().toISOString());
                }

                that.collection.set(model, { add: true, merge: true, remove: false });
                new Notification({
                  message:
                    that.t(
                      that.isNew ? "saved_${a}" : "updated_${a}",
                      { a: that.t("sales_billing") },
                      "capital",
                    ) +
                    ' "' +
                    moment(model.get("date")).format("MMMM YYYY") +
                    '".',
                  duration: 5000,
                  type: "success",
                  closeable: true,
                  icon: "fi fi-check",
                });
                let images = document.getElementsByClassName("rollingLoader");

                _.each(images, (image) => {
                  image.parentNode.removeChild(image);
                });
                $(".button-abort").trigger("click");
              },
              error: function (model, response, options) {
                let message = that.t("request_error");

                if (response.status === 404 || response.statusText === "Not Found") {
                  message = that.t("orders_sales_billings_error");
                }

                if (response.statusText === "error") {
                  message = that.t("orders_sales_billings_error");
                }

                if (typeof response.responseJSON !== "undefined") {
                  const data = response.responseJSON.data;

                  if (response.status === 423 && typeof data.message !== "undefined") {
                    message = that.t("sales_billing_already_exists");
                  }

                  if (
                    typeof data !== "undefined" &&
                    typeof data.errors !== "undefined" &&
                    (typeof data.errors.sales_billing_value !== "undefined") &
                      typeof data.errors.sales_billing_value.greaterThanOrEqual
                  ) {
                    message = that.t("sales_billing_error_value_greater_equal");
                  }
                }

                new Notification({
                  message,
                  duration: 6000,
                  type: "warning",
                  closeable: true,
                  icon: "fi fi-x",
                });
                let images = document.getElementsByClassName("rollingLoader");
                model.set("date", date);
                _.each(images, (image) => {
                  image.parentNode.removeChild(image);
                });
              },
            },
          );
        },
      },
    });
    /*that.model.set('switch1','total');*/
    that.model.set("switch2", "total");

    this.form.render();
    /* $('.switch1').trigger('change');*/
    $(".switch2").trigger("change");
    // Take care that RBAC-methods are executed:
    this.onDomRefresh(this);
  },

  successFunction(model, response) {},

  errorFunction(model, response) {},
});
